import { environment } from '../environments/environment';

export function getAppNamePrefixFromEnvironment() {
  if (!['production', 'prod'].includes(environment.environment_name)) {
    // non prod environments should prefix to naming for clarity
    return environment.environment_name.toUpperCase() + ': ';
  }
  return '';
}

/**
 * The environment token as server-side records store it.
 *
 * Prod builds carry `environment_name: 'production'`, but every stored record
 * uses the short `prod` — the Norrix build webhook maps its configuration through
 * the same short form before writing an Enterprise App Store instance. Callers
 * that look a record up BY environment must normalize first; the Software
 * Security API answers an unknown environment with a 500, not an empty result,
 * so the mismatch reads as an outage rather than a miss.
 *
 * See also `resolveRynReplayEnvironmentLabel` (#30211), which solves the same
 * mismatch for replay envelopes but is web-only and carries replay-specific
 * fallbacks.
 */
export function normalizeEnvironmentName(
  environmentName: string | undefined
): string {
  const raw = (environmentName || '').trim().toLowerCase();
  return raw === 'production' ? 'prod' : raw;
}
